import mercedesClassE from '../assets/cars/mercedes_class_e.png';
import mercedesClassEBreak from '../assets/cars/mercedes_class_e_break.png';
import mercedesClassV from '../assets/cars/mercedes_class_v.png';
import prius from '../assets/cars/prius.png';
import priusPlus from '../assets/cars/prius_2.png';

export const CARS = [
  {
    id: 'mercedes_class_e',
    model: "Mercedes Classe E 220",
    name: "Mercedes Classe E 220",
    seats: 4,
    image: mercedesClassE,
    pricePerKm: 2.5,
  },
  {
    id: 'mercedes_class_e_break',
    model: "Mercedes Classe E 220 Break",
    name: "Mercedes Classe E 220 Break",
    seats: 4,
    image: mercedesClassEBreak,
    pricePerKm: 2.5,
  },
  {
    id: 'mercedes_class_v',
    model: "Mercedes Classe V",
    name: "Mercedes Classe V",
    seats: 8,
    image: mercedesClassV,
    pricePerKm: 3.0,
  },
  {
    id: 'toyota_prius',
    model: "Toyota Prius",
    name: "Toyota Prius",
    seats: 4,
    image: prius,
    pricePerKm: 2.20,
  },
  {
    id: 'toyota_prius_plus',
    model: "Toyota Prius",
    name: "Toyota Prius",
    seats: 4,
    image: priusPlus,
    pricePerKm: 2.2,
  },
]; 